import React from 'react'
import PropTypes from 'prop-types'
import {Input, Select} from 'antd'

CustomerFilters.propTypes = {
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    nameCode: PropTypes.string,
    salePersonName: PropTypes.string,
    parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tenants: PropTypes.array,
    onChangeInput: PropTypes.func.isRequired,
    onChangeParentId: PropTypes.func,
}

function CustomerFilters(props) {
    const {name, email, phone, nameCode, salePersonName, parentId, tenants, onChangeInput, onChangeParentId} = props

    const _handleChangeInput = (e) => {
        onChangeInput(e)
    }

    return (
        <div className="CallHistoryFilters Filters">
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Tên khách hàng</label>
                    <Input
                        name="name"
                        value={name}
                        placeholder="Enter to search..."
                        onChange={_handleChangeInput}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Email</label>
                    <Input
                        name="email"
                        value={email}
                        placeholder="Enter to search..."
                        onChange={_handleChangeInput}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Số điện thoại</label>
                    <Input
                        name="phone"
                        value={phone}
                        placeholder="Enter to search..."
                        onChange={_handleChangeInput}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Mã khách hàng</label>
                    <Input
                        name="nameCode"
                        value={nameCode}
                        placeholder="Enter to search..."
                        onChange={_handleChangeInput}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Thông tin sale</label>
                    <Input
                        name="salePersonName"
                        value={salePersonName}
                        placeholder="Enter to search..."
                        onChange={_handleChangeInput}
                    />
                </div>
            </div>
            <div className="itemFilter">
                <div className="FilterSelect">
                    <label>Parent</label>
                    <Select
                        showSearch
                        allowClear
                        style={{width: '100%'}}
                        value={parentId || undefined}
                        onChange={onChangeParentId}
                        placeholder="All"
                        filterOption={(input, option) =>
                            (option.children).toLowerCase().includes(input.toLowerCase())
                        }
                    >
                        {tenants && tenants.length > 0 && tenants.map(item => (
                            <Select.Option value={item.value} key={item.value}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                </div>
            </div>
        </div>
    )
}

export default CustomerFilters
